import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../../contexts";
import Tooltip from "../Tooltip";

function Button(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const buttonClick=()=>{
    if(props.action === "unselect") {
      compStore.clearSelection();
    }
    compStore.fireAction(props.action, props.data || {});
  };
  const withTooltip=(Comp)=>{
    if(props.tooltip) {
      return (
        <Tooltip text={props.tooltip} placement={"bottom"}>
          {Comp}
        </Tooltip>
      )
    } else {
      return Comp;
    }
  }

  /*if(props.icon_only) {
    return withTooltip(<span onClick={()=>{ buttonClick(); }} className={`${props.icon_class} w5 w1-hover fs24 lh10 pointer`}></span>);
  }*/

  if(!props.condition || props.condition(compStore.items, compStore.by_id)) {
    return withTooltip(
      <span onClick={() => {
        buttonClick();
      }} className={`${props.type} ${props.className} ${props.add_btn_class || null}`}>
        <span>
          {props.mdi ? <span className={`mdi mdi-${props.mdi} `}></span> : null}{props.title || null}
        </span>
      </span>
    );
  }
  return null;
};

Button.defaultProps = {};

Button.propTypes = {}

export default observer(Button);
